import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Toggle from 'react-toggle';
import { Modal } from 'react-bootstrap';

class StaffDesignationRevisionApprovesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      staff_designation: {},
      staff_designations_finalized: {},
      responsibles_to_approve: {},
      staff_to_approve: {},
      required: 0,
    };
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.responsibles_to_approve)) {
      this.setState({
        responsibles_to_approve: newProps.responsibles_to_approve,
        staff_to_approve: newProps.staff_to_approve,
      });
    }
    this.setState({modal: newProps.modal});
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Modal show={self.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Revisão {self.state.staff_designation.number}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.props.modalPropsOff}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {self.state.responsibles_to_approve.length > 0 &&
        <div>
          <table className="table table-bordered table-stripped table-hover">
            <thead>
              <tr>
                <th className="text-center">Gestor</th>
                <th className="text-center">Designação Responsável</th>
                <th className="text-center">Data de Aprovação</th>
              </tr>
            </thead>
            <tbody id="suppliers-certifications">
              {Object.keys(self.state.responsibles_to_approve).map(function(k) {
                return (
                  <tr>
                    <td className="text-center">{self.state.responsibles_to_approve[k].designation_responsible.staff.name}</td>
                    <td className="text-center">{self.state.responsibles_to_approve[k].designation.name}</td>
                    <td className="text-center">{self.state.responsibles_to_approve[k].approval_date_str}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <hr/>
          <table className="table table-bordered table-stripped table-hover">
            <thead>
              <tr>
                <th className="text-center">Colaborador</th>
                <th className="text-center">Data de Ciência</th>
              </tr>
            </thead>
            <tbody id="suppliers-certifications">
              {Object.keys(self.state.staff_to_approve).map(function(k) {
                return (
                  <tr>
                    <td className="text-center">{self.state.staff_to_approve[k].staff_revision.staff.name}</td>
                    <td className="text-center">{self.state.staff_to_approve[k].approval_date_str}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.props.modalPropsOff}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default StaffDesignationRevisionApprovesModal;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffDesignationRevisionApprovesModal.js